import { render, staticRenderFns } from "./PaymentSlipsHeader.vue?vue&type=template&id=4f79d1d9&"
import script from "./PaymentSlipsHeader.vue?vue&type=script&lang=js&"
export * from "./PaymentSlipsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports